import { render } from "./CallenderList.vue?vue&type=template&id=2468d854&scoped=true"
import script from "./CallenderList.vue?vue&type=script&lang=js"
export * from "./CallenderList.vue?vue&type=script&lang=js"

import "./CallenderList.vue?vue&type=style&index=0&id=2468d854&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2468d854"]])

export default __exports__